export default __webpack_public_path__ + "25f04e3d4ef81734de2067b5f215c66d.png";